import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { NavbarDashbord } from './navbarDashbord';
import { Plus, Edit2, Trash2, Info, X, MapPin, Building, Calendar, Box, ChevronDown, ChevronUp } from 'lucide-react';
import { deleteProjet } from './action';
import '../styles/admin.css';

export function PageProjets() {
    const projectsList = useSelector(state => state.listP) || [];
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [selectedProjet, setSelectedProjet] = useState(null);
    const [filter, setFilter] = useState('Toutes les villes');
    const [openProjectCards, setOpenProjectCards] = useState({ partenariats: false, calendrier: false });

    const toggleProjectCard = (key) => {
        setOpenProjectCards(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
    };
    
    // Confirmation delete modal
    const [confirmDeleteProjet, setConfirmDeleteProjet] = useState(null);
    const [deleteError, setDeleteError] = useState('');

    const handleSupprimer = (id) => {
        const projet = projectsList.find(p => p.id === id);
        setConfirmDeleteProjet(projet || { id, nomProjet: "ce projet" });
        setDeleteError('');
    };

    const confirmDeleteAction = () => {
        if (confirmDeleteProjet) {
            setDeleteError('');
            dispatch(deleteProjet(confirmDeleteProjet.id))
                .unwrap()
                .then(() => {
                    setConfirmDeleteProjet(null);
                })
                .catch((err) => {
                    console.error("Delete projet error:", err);
                    const msg = err?.response?.data?.message || err?.message || "Erreur lors de la suppression.";
                    setDeleteError(`Erreur: ${msg}`);
                });
        }
    };

    const uniqueVilles = [...new Set(projectsList.map(p => p.ville))].filter(Boolean);

    const projectsToDisplay = filter === 'Toutes les villes'
        ? projectsList
        : projectsList.filter(p => p.ville === filter);

    return (
        <div className="admin-layout">
            <NavbarDashbord />
            <main className="admin-main-content">
                <header className="admin-header">
                    <div className="admin-title-group">
                        <h1>Gestion des Projets</h1>
                        <p>Total de {projectsToDisplay.length} réalisations architecturales et industrielles.</p>
                    </div>
                </header>

                <div className="admin-table-container">
                    <div className="table-header-actions">
                        <div className="admin-filters">
                            <select
                                className="admin-select"
                                value={filter}
                                onChange={(e) => setFilter(e.target.value)}
                            >
                                <option value="Toutes les villes">Toutes les villes</option>
                                {uniqueVilles.map((ville, idx) => (
                                    <option key={idx} value={ville}>{ville}</option>
                                ))}
                            </select>
                        </div>
                        <button className="admin-btn-add" onClick={() => navigate('/admin-projet/add')}>
                            <Plus size={20} />
                            <span className="btn-text-full">Ajouter un Projet</span>
                            <span className="btn-text-short">Ajouter</span>
                        </button>
                    </div>

                    <table className="admin-table">
                        <thead>
                            <tr>
                                <th>Projet</th>
                                <th>Ville</th>
                                <th>Année / Durée</th>
                                <th>Localisation</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {projectsToDisplay.map((p) => (
                                <tr key={p.id}>
                                    <td>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                            <div className="table-img-wrapper" style={{ width: '45px', height: '45px', borderRadius: '10px', overflow: 'hidden', border: '1px solid var(--admin-border)' }}>
                                                <img src={p.imageProjet} alt={p.nomProjet} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                            </div>
                                            <div>
                                                <p style={{ margin: 0, fontWeight: '800', color: 'var(--admin-primary)' }}>{p.nomProjet}</p>
                                                <span style={{ fontSize: '0.65rem', color: 'var(--admin-text-muted)' }}>ID: #{p.id}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <span className="admin-badge" style={{ background: 'rgba(99, 102, 241, 0.1)', color: 'var(--admin-accent)' }}>
                                            {p.ville}
                                        </span>
                                    </td>
                                    <td>
                                        <div style={{ fontSize: '0.8rem', fontWeight: '700' }} className='date-surface-container'>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }} className='calendrar-icon'>
                                                <Calendar size={12} color="var(--admin-secondary)" />
                                                {p.annee}
                                            </div>
                                            <div style={{ color: 'var(--admin-text-muted)', fontSize: '0.7rem' }}>Surface: {p.surface}</div>
                                        </div>
                                    </td>
                                    <td>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '0.8rem' }} className='location-container'>
                                            <MapPin size={14} color="var(--admin-danger)" />
                                            {p.location}
                                        </div>
                                    </td>
                                    <td>
                                        <div className="action-btns">
                                            <button
                                                className="btn-icon btn-view"
                                                onClick={() => setSelectedProjet(p)}
                                                title="Détails"
                                            >
                                                <Info size={16} />
                                            </button>
                                            <button
                                                className="btn-icon btn-modify"
                                                onClick={() => navigate(`/admin-projet/edit/${p.id}`)}
                                                title="Modifier"
                                            >
                                                <Edit2 size={16} />
                                            </button>
                                            <button
                                                className="btn-icon btn-delete"
                                                onClick={() => handleSupprimer(p.id)}
                                                title="Supprimer"
                                            >
                                                <Trash2 size={16} />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            {projectsToDisplay.length === 0 && (
                                <tr>
                                    <td colSpan="5" style={{ textAlign: 'center', padding: '40px', color: 'var(--admin-text-muted)' }}>
                                        Aucun projet trouvé dans cette ville.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Project Details Modal */}
                {selectedProjet && (
                    <div className="admin-modal-overlay" onClick={() => setSelectedProjet(null)}>
                        <div className="admin-modal-content" onClick={(e) => e.stopPropagation()}>
                            <div className="modal-header">
                                <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                    <div style={{ width: '80px', height: '80px', borderRadius: '15px', overflow: 'hidden', border: '1px solid #eee' }}>
                                        <img src={selectedProjet.imageProjet} alt={selectedProjet.nomProjet} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                    </div>
                                    <div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <h2 style={{ margin: 0, color: 'var(--admin-primary)' }}>{selectedProjet.nomProjet}</h2>
                                            <span style={{ backgroundColor: 'rgba(99, 102, 241, 0.15)', color: 'var(--admin-accent)', padding: '4px 10px', borderRadius: '20px', fontSize: '0.7rem', fontWeight: '800' }}>
                                                {selectedProjet.ville}
                                            </span>
                                        </div>
                                        <p style={{ margin: '5px 0 0', color: 'var(--admin-secondary)', fontWeight: '700' }}>Réf: #{selectedProjet.id}</p>
                                    </div>
                                </div>
                                <button className="modal-close-btn" onClick={() => setSelectedProjet(null)}>&times;</button>
                            </div>

                            <div className="modal-body">
                                <div className="modal-section">
                                    <h3>Description du Projet</h3>
                                    <p style={{ lineHeight: '1.6', fontSize: '0.9rem', color: '#444' }}>{selectedProjet.description}</p>
                                </div>

                                <div className="modal-section">
                                    <h3>Fiche Technique & Réalisation</h3>
                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '20px' }}>
                                        <div className="spec-card">
                                            <div className="spec-card-header" onClick={() => toggleProjectCard('partenariats')}>
                                                <span>Partenariats</span>
                                                <div className="spec-card-toggle">
                                                    {openProjectCards.partenariats ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                                                </div>
                                            </div>
                                            <div className={`spec-card-body ${openProjectCards.partenariats ? 'open' : ''}`}>
                                                <div className="spec-item">
                                                    <span>Client:</span>
                                                    <strong>{selectedProjet.societeConception}</strong>
                                                </div>
                                                <div className="spec-item">
                                                    <span>Partenaire:</span>
                                                    <strong>{selectedProjet.societeRéalisation}</strong>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="spec-card">
                                            <div className="spec-card-header" onClick={() => toggleProjectCard('calendrier')}>
                                                <span>Calendrier & Géo</span>
                                                <div className="spec-card-toggle">
                                                    {openProjectCards.calendrier ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                                                </div>
                                            </div>
                                            <div className={`spec-card-body ${openProjectCards.calendrier ? 'open' : ''}`}>
                                                <div className="spec-item">
                                                    <span>Date / Surface:</span>
                                                    <strong>{selectedProjet.annee} ({selectedProjet.surface})</strong>
                                                </div>
                                                <div className="spec-item">
                                                    <span>Localisation:</span>
                                                    <strong>{selectedProjet.location}</strong>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="modal-section">
                                    <h3>Géo-localisation (Google Maps)</h3>
                                    <div className="map-preview-container">
                                        <iframe
                                            width="100%"
                                            height="100%"
                                            frameBorder="0"
                                            src={`https://maps.google.com/maps?q=${selectedProjet.coordonnees?.lat},${selectedProjet.coordonnees?.lng}&z=14&output=embed`}
                                            title="Project Map Preview"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Confirmation Delete Modal */}
                {confirmDeleteProjet && (
                    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
                        <style>{`
                            @keyframes shakeError {
                                0%, 100% { transform: translateX(0); }
                                20%, 60% { transform: translateX(-5px); }
                                40%, 80% { transform: translateX(5px); }
                            }
                        `}</style>
                        <div style={{ background: 'var(--admin-card-bg)', borderRadius: '16px', padding: '36px', maxWidth: '420px', width: '90%', boxShadow: '0 20px 60px rgba(0,0,0,0.3)', border: '1px solid var(--admin-border)' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '18px' }}>
                                <div style={{ width: '48px', height: '48px', borderRadius: '50%', background: 'rgba(239,68,68,0.12)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <Trash2 size={22} color="var(--admin-danger)" />
                                </div>
                                <div>
                                    <h3 style={{ margin: 0, fontSize: '1.05rem', color: 'var(--admin-text-main)', fontWeight: 700 }}>Supprimer le projet</h3>
                                    <p style={{ margin: 0, fontSize: '0.82rem', color: 'var(--admin-text-muted)' }}>Cette action est irréversible.</p>
                                </div>
                            </div>
                            
                            {deleteError && (
                                <div style={{ background: '#fee2e2', color: '#dc2626', padding: '12px 16px', borderRadius: '8px', marginBottom: '16px', fontSize: '0.85rem', fontWeight: 600, animation: 'shakeError 0.4s ease-in-out', border: '1px solid #fca5a5' }}>
                                    {deleteError}
                                </div>
                            )}

                            <p style={{ fontSize: '0.9rem', color: 'var(--admin-text-main)', marginBottom: '24px', lineHeight: 1.6 }}>
                                Êtes-vous sûr de vouloir supprimer le projet <strong>{confirmDeleteProjet.nomProjet}</strong> ?
                            </p>
                            <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                                <button onClick={() => { setConfirmDeleteProjet(null); setDeleteError(''); }} style={{ padding: '10px 22px', borderRadius: '8px', border: '1px solid var(--admin-border)', background: 'transparent', color: 'var(--admin-text-main)', cursor: 'pointer', fontWeight: 600 }}>Annuler</button>
                                <button onClick={confirmDeleteAction} style={{ padding: '10px 22px', borderRadius: '8px', border: 'none', background: 'var(--admin-danger)', color: '#fff', cursor: 'pointer', fontWeight: 700 }}>Supprimer définitivement</button>
                            </div>
                        </div>
                    </div>
                )}
            </main>
        </div>
    );
}
